import { useEffect, useState } from "react";
import { DisclosureHost } from "../../../../../../../hooks/use-disclosure";
import StyledFormModal from "../../../../../../../components/globalModal/StyledModal";
import AssessmentCategoryPicker, {
  AssessmentCategory,
} from "./AssessmentCategoryPicker";
import HomeCareScreeningLayout from "./HomeCareScreeningLayout";
import ScreeningStartNewLayout from "./ScreeningStartNewLayout";

interface StartNewAssessmentDrawerProps {
  disclosureHost: DisclosureHost;
}

const StartNewAssessmentDrawer = ({
  disclosureHost,
}: StartNewAssessmentDrawerProps) => {
  const [category, setCategory] = useState<AssessmentCategory | null>(null);

  useEffect(() => {
    if (!disclosureHost.opened) setCategory(null);
  }, [disclosureHost.opened]);

  const close = () => disclosureHost.close();

  return (
    <StyledFormModal
      open={disclosureHost.opened}
      onClose={close}
      dialogTitle="New Screening Assessment"
      sx={{
        "& .MuiDialog-paper": {
          width: "80vw",
          height: "80vh",
        },
      }}
    >
      {category === null ? (
        <AssessmentCategoryPicker onPick={setCategory} />
      ) : category === "HOME_CARE" ? (
        <HomeCareScreeningLayout
          onBack={() => setCategory(null)}
          onClose={close}
        />
      ) : (
        <ScreeningStartNewLayout onClose={close} />
      )}
    </StyledFormModal>
  );
};

export default StartNewAssessmentDrawer;
